import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, type SxProps } from "@mui/material";
import { TextInput } from "react-admin";

export function SearchFilterInput(props: {
  source: string;
  placeholder?: string;
  alwaysOn?: boolean;
  resettable?: boolean;
  sx?: SxProps;
}) {
  const { source, placeholder = "Suche", alwaysOn, resettable, sx } = props;

  return (
    <TextInput
      label=""
      placeholder={placeholder}
      source={source}
      alwaysOn={alwaysOn}
      resettable={resettable}
      sx={{
        maxWidth: "200px",
        "& .MuiInputBase-input::placeholder": {
          color: "text.disabled",
          opacity: 1,
        },
        ...sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 20, color: "text.disabled" }} />
          </InputAdornment>
        ),
        inputProps: {
          "aria-label": placeholder,
        },
      }}
    />
  );
}
